import axios from './_nestAxios'

export const obtenerBloqueos = () => axios.get('/bloqueos-periodos')

export const obtenerTcMayorizado = mes =>
  axios.get('/bloqueos-periodos/tc-mayorizado', {
    params: { mes }
  })

export const actualizarBloqueos = data => axios.put('/bloqueos-periodos', data)
